const Type = Object.freeze({
  PATH: 'PATH',
  RECTANGLE: 'RECTANGLE',
  CIRCLE: 'CIRCLE'
})

export { Type }
export default Type
